/* eslint-disable no-unused-vars */
'use client';

import { createContext, useState, ReactNode } from 'react';

export type SnackbarSize = 1 | 2 | 3;
export type SnackbarVariant = 'soft' | 'solid' | 'outline';
export type SnackbarColor =
  | 'accent'
  | 'neutral'
  | 'error'
  | 'success'
  | 'warning'
  | 'info';

interface SnackbarProps {
  visivel: boolean;
  mensagem: string;
  color: SnackbarColor;
  size: SnackbarSize;
  highContrast: boolean;
  variant: SnackbarVariant;
  callbackFunction?: () => void;
  textoBotao?: string;
}
interface MostrarSnackbarProps {
  mensagem: string;
  color: SnackbarColor;
  size: SnackbarSize;
  highContrast: boolean;
  variant: SnackbarVariant;
  callbackFunction?: () => void;
  textoBotao?: string;
}
interface SnackbarContextType {
  snackbarProps: SnackbarProps;
  mostrarSnackbar: ({
    mensagem,
    color,
    size,
    highContrast,
    callbackFunction,
    textoBotao,
  }: MostrarSnackbarProps) => void;
  esconderSnackbar: () => void;
}

export const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined,
);

export const SnackbarProvider = ({ children }: { children: ReactNode }) => {
  const snarbarDefault: SnackbarProps = {
    visivel: false,
    mensagem: '',
    variant: 'soft',
    color: 'info',
    size: 1,
    highContrast: false,
    callbackFunction: undefined,
    textoBotao: undefined,
  };

  const [snackbarProps, setSnackbarProps] =
    useState<SnackbarProps>(snarbarDefault);

  const mostrarSnackbar = (props: MostrarSnackbarProps) => {
    setSnackbarProps({
      visivel: true,
      ...props,
    });
  };

  const esconderSnackbar = () => {
    setSnackbarProps((propsAntigas) => {
      return {
        ...propsAntigas,
        visivel: false,
      };
    });
    setTimeout(() => {
      setSnackbarProps(snarbarDefault);
    }, 400);
  };

  return (
    <SnackbarContext.Provider
      value={{ snackbarProps, mostrarSnackbar, esconderSnackbar }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};
